/**
 * Storage utility for client-side preferences
 * Provides safe localStorage operations with error handling
 */

export const storageKeys = {
  REMEMBERED_USERNAME: 'remembered_username',
};

export const storage = {
  /**
   * Save a value to localStorage
   * @param {string} key - Storage key
   * @param {*} value - Value to store (will be JSON stringified)
   */
  setItem(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(`Error saving to storage: ${key}`, error);
    }
  },

  /**
   * Get a value from localStorage
   * @param {string} key - Storage key
   * @param {*} defaultValue - Default value if key doesn't exist
   * @returns {*} Parsed value or defaultValue
   */
  getItem(key, defaultValue = null) {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : defaultValue;
    } catch (error) {
      console.error(`Error reading from storage: ${key}`, error);
      return defaultValue;
    }
  },

  /**
   * Remove a value from localStorage
   * @param {string} key - Storage key
   */
  removeItem(key) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Error removing from storage: ${key}`, error);
    }
  },

  /**
   * Save username to remember for future sign-ins
   * @param {string} username - Username/email to remember
   */
  rememberUsername(username) {
    this.setItem(storageKeys.REMEMBERED_USERNAME, username);
  },

  /**
   * Get the remembered username
   * @returns {string|null} Saved username or null if not found
   */
  getRememberedUsername() {
    return this.getItem(storageKeys.REMEMBERED_USERNAME);
  },

  /**
   * Clear the remembered username
   */
  forgetUsername() {
    this.removeItem(storageKeys.REMEMBERED_USERNAME);
  },
};
